var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';

var RepairFacilityRatingCtrl = function () {
    function RepairFacilityRatingCtrl() {
        _classCallCheck(this, RepairFacilityRatingCtrl);

        this.MAX_RATE = 5;
        this.starsRange = _.range(1, this.MAX_RATE + 1);
    }

    _createClass(RepairFacilityRatingCtrl, [{
        key: 'getScaledRate',
        value: function getScaledRate() {
            return this.rate ? this.rate / 100.0 * this.MAX_RATE : 0.0;
        }
    }, {
        key: 'getNumericRate',
        value: function getNumericRate() {
            return this.getScaledRate().toFixed(1);
        }
    }, {
        key: 'isActiveStar',
        value: function isActiveStar(starNumber) {
            return starNumber <= Math.round(this.getScaledRate());
        }
    }]);

    return RepairFacilityRatingCtrl;
}();

export default RepairFacilityRatingCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilityRating/RepairFacilityRatingCtrl.js
// module id = 1572
// module chunks = 0